import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// I18n
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
  Grid,
  Paper,
  FormControl,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  InputLabel,
  MenuItem,
} from "./index";

import "date-fns";
import Styles from "./styles";
import SectionHead from "../../components/SectionHead";
import { AccessTime as Watch, DateRange, Close } from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import {
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Chip
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Controller, useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import { getLocationForCountry } from "services/bulkUpload";


const AddEditActivityView = (props) => {
  const classes = Styles();
  const { t , i18n} = useTranslation();
  const { control, setValue, getValues, errors, clearErrors } =
    useFormContext();
    const {setIsJobFamilyRestricted , isJobFamilyRestricted ,jobFamily ,setJobFamily, 
        setEndDateErrMsg , setEndDateErr , endDateErr,setEndDate,endDate,isDistrictRestricted,
        setIsDistrictRestricted, restrictedDistricts, setRestrictedDistricts,
    startDate,setStartDate , setStartDateErr, startDateErr,setStartDateErrMsg ,setType, type, isProjectData,defaultRestrictedDistricts} =props;
    const { jobFamilies } = useSelector((state) => state.appConfig);
    const { user, isAuthenticated } = useSelector((state) => state.user.auth);
    const [jobRoles, setJobRoles] = useState([]);
    const [actGrpError, setActGrpError] = useState(false);
    const [districtList, setDistrictList] = useState([]);
    const activityGroupLabel = t("other.lblActivityGroup") + " *";

    useEffect(()=>{
       
      if(startDate){
        if(!moment(startDate).isValid()){
            setStartDateErr(true);
            setStartDateErrMsg(t("other.errInvalidDate"));
        }else{
          setStartDateErr(false);
          setStartDateErrMsg("");
        }
        
      } 

      if(endDate){
        if(!moment(endDate).isValid()){
            setEndDateErr(true);
            setEndDateErrMsg(t("other.errInvalidDate"));
        }else{
          setEndDateErr(false);
          setEndDateErrMsg("");
        }
        
      } 
    },[startDate,endDate])
  
    const jobFamilyValidation = (values) =>
    console.log("error:",values.length !== 0 && jobFamily) ||
    (values.length !== 0 && jobFamily);

    const distListValidation = (values) =>
    console.log("error:",values.length !== 0 && restrictedDistricts) ||
    (values.length !== 0 && restrictedDistricts);

    useEffect(() => {
      if (jobFamilies && i18n) {
        const language = i18n.language;              
        const values = jobFamilies[language]
          ? jobFamilies[language]
          : jobFamilies["en"];
        const jobRolesList = values.map((item) => item.value);
        setJobRoles(jobRolesList);
      }
    }, [jobFamilies, i18n]);

    useEffect(()=>{
        if(user && user.country){
          getLocationForCountry(
            user.countryCode,
            user.country
            ).then(data =>{
            console.log("userDetails",user.country, data);
            const distList = data.length>0 ? data.map(ele => ele.district):[];
            setDistrictList(distList);
          }).catch(err =>{
            console.log("error fetching user country district list ::", err);
            setDistrictList([]);
          })
        }
    },[user])
 
  return (
    <>
      <Grid container direction="row" justify="center">
        <Grid item sm={7} xs={12}>
          <Paper elevation={3} className={classes.card}>
            <SectionHead back={props.backHandler} name={props.pageTitle} />
            <form>
              <Grid item xs={12} sm={12}>
                <FormControl className={classes.formControl}>

                  <TextField
                    required
                    id="activity-name"
                    label={t("other.lblActivityName")}
                    type="text"
                    fullWidth
                    value={props.name}
                    onChange={props.onChangeName}
                    onBlur={props.onChangeName}
                    placeholder={t("other.phEnterName")}
                    error={props.nameErr}
                    helperText={props.nameErrMsg}
                    inputProps={{ maxLength: 100 }}
                    disabled={isProjectData}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl className={classes.formControl}
                >
                  <InputLabel id="activity-group-label"  error={actGrpError}>
                    {activityGroupLabel}
                  </InputLabel>
                  <Select
                    required
                    labelId="activity-label"
                    id="activity-select"
                    value={props.type}
                   error={actGrpError}
                   disabled={isProjectData}
                    onBlur={(event) => {
                      const val = event.target.value;
                      if(val ===-1){
                        setActGrpError(true);
                      }else setActGrpError(false);
                       setType(val);
                   }}
                    onChange={(event) => {
                     const val = event.target.value;
                     if(val ===-1){
                      setActGrpError(true);
                    }else setActGrpError(false);
                      setType(val);
                  }}
                  >
                    {props.activityGroupOptions.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid container xs={12} sm={12} >
                
              <Grid item xs={12} sm={12} lg={6} >
              <FormControlLabel className={classes.formControl} style={{marginBottom:'0px'}}
                  control={
                    <Controller
                      name="jobFamilyRestricted"
                      control={control}
                      defaultValue={isJobFamilyRestricted}
                      render={(props) => (
                        <>
                          <Checkbox 
                            {...props}
                            checked={isJobFamilyRestricted}
                            onChange={(e) => {
                              setIsJobFamilyRestricted(e.target.checked);
                              props.onChange(e.target.checked);
                            }}
                            color="primary"
                            // style={{ paddingLeft: 0 }}
                            inputRef={props.ref}
                          />
                        </>
                      )}
                    />
                  }
                  label={t("other.lblJobRoleRestricted")}
                />

              <div className={classes.formControl}>
                    <Controller
                        name="jobFamily"
                        control={control}
                        defaultValue={jobFamily}
                        disabled={!isJobFamilyRestricted}
                        rules={{
                          validate: jobFamily ? jobFamilyValidation : true,
                        }}
                        render={(props) => (
                          <Autocomplete
                            size="small"
                            multiple
                          //  style={{ marginTop: 20, marginBottom: 20 }}
                            options={jobRoles}
                            value={jobFamily}
                            disableClearable
                            disabled={!isJobFamilyRestricted}
                           //  getOptionLabel={(option) => option.label}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // {...props}
                                style={{ maxWidth: 320 }}
                                id="jobFamily"
                                name="jobFamily"
                                label={t("other.lblSelectJobRole")}
                                required={getValues("jobFamilyRestricted")}
                                error={
                                  Boolean(errors.jobFamily) && isJobFamilyRestricted
                                }
                                helperText={
                                  errors?.jobFamily?.type === "validate"
                                    ? t("other.lblJobRoleCannotBeBlank") 
                                    : ""
                                }
                              />
                            )}
                            onChange={(e, val) => {
                              props.onChange(val);
                              setJobFamily(val);
                            }}
                          />
                        )}
                      />
                  </div> 
              </Grid>   

              <Grid item xs={12} sm={12} lg={6}>
              <FormControlLabel className={classes.formControl} style={{marginBottom:'0px'}}
                  control={
                    <Controller
                      name="districtRestricted"
                      control={control}
                      defaultValue={isDistrictRestricted}
                      render={(props) => (
                        <>
                          <Checkbox 
                            {...props}
                            checked={isDistrictRestricted}
                            disabled={defaultRestrictedDistricts && defaultRestrictedDistricts.length > 0}
                            onChange={(e) => {
                              setIsDistrictRestricted(e.target.checked);
                              props.onChange(e.target.checked);
                            }}
                            color="primary"
                            // style={{ paddingLeft: 0 }}
                            inputRef={props.ref}
                          />
                        </>
                      )}
                    />
                  }
                  label={t("other.isDistrictRestricted")}
                />

              <div className={classes.formControl}>
                    <Controller
                        name="restrictedDistricts"
                        control={control}
                        defaultValue={restrictedDistricts}
                        disabled={!isDistrictRestricted}
                        rules={{
                          validate: restrictedDistricts.length>0 ? distListValidation : true,
                        }}
                        render={(props) => (
                          <Autocomplete
                            size="small"
                            multiple
                          //  style={{ marginTop: 20, marginBottom: 20 }}
                           options={districtList}
                            value={restrictedDistricts}
                            disableClearable
                            disabled={!isDistrictRestricted}
                           //  getOptionLabel={(option) => option.label}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                // {...props}
                                style={{ maxWidth: 320 }}
                                id="restrictedDistricts"
                                name="restrictedDistricts"
                                label={t("general.select1")}
                                required={getValues("restrictedDistricts")}
                                error={
                                  Boolean(errors.restrictedDistricts) && isDistrictRestricted
                                }
                                helperText={
                                  errors?.restrictedDistricts?.type === "validate" && isDistrictRestricted
                                    ? t("other.lblDistBlankErr") 
                                    : ""
                                }
                              />
                            )}
                            renderTags={(tagValue, getTagProps) =>
                              tagValue.map((option, index) => (
                                <Chip
                                  label={option}
                                  {...getTagProps({ index })}
                                  disabled={defaultRestrictedDistricts && defaultRestrictedDistricts.indexOf(option) !== -1}
                                />
                              ))
                            }
                            onChange={(e, val) => {
                              props.onChange(val);
                              setRestrictedDistricts(val);
                            }}
                          />
                        )}
                      />
                  </div> 
              </Grid>   
              </Grid>

              <Grid item xs={12} sm={12}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    ampm={false}
                    disableBackdropClick
                    placeholder="dd/MM/yyyy" //{t("pgPunch.subTextCustomerSite")}
                    margin="normal"
                    id="date-picker-dialog"
                    label={t("other.lblActivityStartDate")}
                    format="dd/MM/yyyy"
                    value={props.startDate}
                    disabled={isProjectData}
                    onChange={(newValue) => {
                      setStartDate(newValue);
                  }}
                    KeyboardButtonProps={{
                      "aria-label": "Select Activity Start Date",
                    }}
                    className={classes.formControl}
                    error={props.startDateErr}
                    helperText={props.startDateErrMsg}
                    invalidDateMessage={t("other.errInvalidDate")}
                    keyboardIcon={<DateRange fontSize="" />}
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={12} sm={12}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    ampm={false}
                    disableBackdropClick
                    placeholder="dd/MM/yyyy" //{t("pgPunch.subTextCustomerSite")}
                    margin="normal"
                    id="date-picker-dialog"
                    label={t("other.lblActivityEndDate")}
                    format="dd/MM/yyyy"
                    value={props.endDate}
                    disabled={isProjectData}
                    onChange={(newValue) => {
                      if(newValue){
                        var dateTarget = new Date(newValue);
                        dateTarget.setHours(23)
                        dateTarget.setMinutes(59)
                        dateTarget.setSeconds(59)
                        setEndDate(dateTarget);
                      }else setEndDate("");
                     
                    }}
                    KeyboardButtonProps={{
                      "aria-label": t("other.lblSelectActivityEndDate"),
                    }}
                     
                    className={classes.formControl}
                    error={props.endDateErr}
                    helperText={props.endDateErrMsg}
                    invalidDateMessage={t("other.errInvalidDate")}
                    keyboardIcon={<DateRange fontSize="" />}
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControlLabel
                  className={(classes.formControl, classes.left)}
                  labelPlacement="start"
                  control={
                    <Checkbox
                      defaultChecked="false"
                      color="primary"
                      checked={props.isActive}
                      onChange={props.onChangeIsActive}
                      id="chk-active"
                      name="active-activity"
                      disabled={isProjectData}
                    />
                  }
                  label={t("pgAddWorker.lblIsActive")}
                />
              </Grid>

              {/* save and cancel buttons */}
              <Grid container direction="row" justify="flex-end">
                <Grid item>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={props.onCancel}
                    className={classes.button}
                  >
                    {t("general.cancelBtn")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={props.onSave}
                    className={classes.button}
                    disabled={props.disableSave}
                  >
                    {t("general.saveBtn")}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>

      <Dialog
        open={props.loading}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="dialog-title">{t("other.tlProcessing")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container justify="center">
              <Grid item>
                <CircularProgress className={classes.center} />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={props.success}
        onClose={props.onSuccess}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>{props.confirmationMsg}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onSuccess} color="primary">
            {t("pgPunch.btnOK")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

AddEditActivityView.propTypes = {
  backHandler: PropTypes.func,
  pageTitle: PropTypes.string,
  type: PropTypes.any,
  onChangeType: PropTypes.func,
  activityGroupOptions: PropTypes.any,
  name: PropTypes.any,
  onChangeName: PropTypes.func,
  startDate: PropTypes.any,
  onChangeStartDate: PropTypes.func,
  endDate: PropTypes.any,
  onChangeEndDate: PropTypes.func,
  isActive: PropTypes.any,
  onChangeIsActive: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  disableSave: PropTypes.bool,
  startDateErr: PropTypes.bool,
  startDateErrMsg: PropTypes.any,
  endDateErr: PropTypes.bool,
  endDateErrMsg: PropTypes.any,
  loading: PropTypes.bool,
  success: PropTypes.bool,
  onSuccess: PropTypes.func,
  nameErr: PropTypes.bool,
  nameErrMsg: PropTypes.any,
  confirmationMsg: PropTypes.any,
};

export default AddEditActivityView;
